<template>
<section class="hero section-header">

    <!-- <Searchbar /> -->

  <div class="hero-foot">
    <div class="container">
        <div class="header-logo-and-text">

            <div class="header-logo-image">
                <router-link class="custom-logo-link" tag="a" :to = "{name: 'home'}"><img width="40" height="47" src="/images/icons/logo.png" srcset="/images/icons/logo@2x.png 2x" class="custom-logo" alt="Logo"></router-link>
            </div>
            <div class="header-text">
                <h1 class="title">
                    <router-link tag="a" :to = "{name: 'home'}" class="navband">Combined Actors of Cambridge</router-link>
                </h1>
                <h2 class="subtitle">50+ years of stage excellence</h2>
            </div>

        </div>

        <nav class="secondarylinks">
            <div class="level-right">
                <p class="level-item" v-for="link in secondarylinks" :key="link._id" :class="{ 'secondarylink-selected': link.routelink == currentRoute }">
                    <router-link tag="a" :to = "{name: link.routelink, params: {}}" class="nav-link">{{ link.name }}</router-link>
                </p>
                <p class="level-item" v-if="isProfileLoaded" :class="{ 'secondarylink-selected': 'account' == currentRoute }">
                    <router-link to="/account">{{name}}</router-link>
                </p>
                <p class="level-item" v-if="isAuthenticated" @click="logout">
                    <a class="logout">Logout</a>
                </p>
            </div>
        </nav>

        <div class="tabs is-boxed is-right">
          <ul>
            <li v-for="tab in tabs" :key="tab._id" :class="{ 'is-active': tab.routelink == currentRoute }">

              <router-link tag="a" :to="{name: tab.routelink}" class="nav-link">
                <span>{{ tab.name }}</span>
              </router-link>
            </li>
            <li v-if="isAuthenticated" :class="{ 'is-active': 'admin' == currentRoute }">
              <router-link tag="a" :to="{name: 'admin'}" class="nav-link">
                <span>ADMIN</span>
              </router-link>
            </li>
          </ul>
        </div>
    </div>
  </div>
      
</section>
</template>

<script>
import Api from '@/config/Api'
//import Searchbar from './Searchbar.vue'


import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '../store/actions/auth.js'
import mixins from '@/mixins/mixins'

export default {
    data() {
        return {
            currentRoute: '',
            tabs: [
                {
                    _id: 0,
                    name: "What's on",
                    routelink: "whatson"
                },
                {
                    _id: 1,
                    name: "Get involved",
                    routelink: "getinvolved"
                },
                {
                    _id: 3,
                    name: "Previous productions",
                    routelink: "previousproductions"
                },
            ],
            secondarylinks: [
                {
                    _id: 0,
                    name: "Blog",
                    routelink: "blogs"
                },
                {
                    _id: 1,
                    name: "Contact us",
                    routelink: "contact"
                },
                {
                    _id: 3,
                    name: "About",
                    routelink: "about"
                },
            ],
            categories: []
        }
    },
    components: {
        //Searchbar,
    },
    mixins: [mixins],
    created() {
        this.checkRoute();
    },
    computed: {
        ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
        ...mapState({
          authLoading: state => state.status === 'loading',
          name: state => `${state.user.profile.name}`, 
        }),
    },
    watch: {
        '$route' (to, from) {
            console.log("ROUTE CHANGED to.params:",to.params);
            // console.log("from.params:",from.params);
            this.checkRoute();
            /* if (from.params.category !== to.params.category) {
                this.fetch()
            } */
        }
    },
    methods: {
        checkRoute() {
            // console.log('currentRoute:', this.$router.currentRoute.name);
            this.currentRoute = this.$router.currentRoute.name;
        },
        logout() {
           this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/admin-edit-tool/login'))

        /* localStorage.removeItem('jwtToken')
        Api().get('/api/logout')
        .then(() => {
          bus.$emit('refreshUser');
          this.$router.push({ name: 'home' });
        })
        .catch(() => {
        }); */
        },
    },
}
</script>

<style scoped>
.section-header {
    background-color: #354049;
    padding-top: 0.75rem;
}


.header-logo-and-text {
    float: left;
    padding-left: 0.75rem;
}
.header-logo-image {
    float: left
}
.header-logo-image img {
    display: block
}
.header-text {
    margin-left: 55px;
    max-width: 210px;
}
.header-text a {
    color: white;
    font-size: 24px;
}
.header-text .title {
    line-height: 24px;
}
.subtitle {
    font-size: 15px;
    color: #CFCFCF;
}
.secondarylinks {
    margin-top: 1em;
    font-size: 85%;
    font-weight: bold;
}
.secondarylinks a {
    color: white;
}
.secondarylink-selected a {
    color: #8BEAE9;
}
.tabs {
    font-weight: bold;
    font-size: 1.2rem;
    margin-top: 40px;
}


</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue